export const REALTIME_EVENTS = {
  BROKER_PUBLISHED_OFFER:
    process.env.REACT_APP_RT_BROKER_PUBLISHED_OFFER || "broker.published_offer",
  BROKER_UNPUBLISH_OFFER:
    process.env.REACT_APP_RT_BROKER_UNPUBLISH_OFFER || "broker.unpublish_offer",
  BROKER_THREAD_NOTIFICATION:
    process.env.REACT_APP_RT_BROKER_THREAD_NOTIFICATION ||
    "broker.thread_notification",
  REINSURER_INTEREST:
    process.env.REACT_APP_RT_REINSURER_INTEREST || "reinsurer.interest",
  REINSURER_REMOVE_INTEREST:
    process.env.REACT_APP_RT_REINSURER_REMOVE_INTEREST ||
    "reinsurer.remove_interest",
  REINSURER_READ_THREAD:
    process.env.REACT_APP_RT_REINSURER_READ_THREAD || "reinsurer.read_thread",
  REINSURER_THREAD_NOTIFICATION:
    process.env.REACT_APP_RT_REINSURER_THREAD_NOTIFICATION ||
    "reinsurer.thread_notification",
  BROKER_ACCEPTED_INTEREST:
    process.env.REACT_APP_RT_BROKER_ACCEPTED_INTEREST ||
    "broker.accepted_interest",
  BROKER_REMOVE_REINSURER_INTEREST:
    process.env.REACT_APP_RT_BROKER_REMOVE_REINSURER_INTEREST ||
    "broker.remove_reinsurer_interest",
  BROKER_READ_THREAD:
    process.env.REACT_APP_RT_BROKER_READ_THREAD || "broker.read_thread",
  CLOSED_BUSINESS:
    process.env.REACT_APP_RT_CLOSED_BUSINESS ||
    "LgzULSz64aed7WJ7YwDq3qmHAeX786dZNZ3Ko4Bisf0-event",
} as const;

export const REALTIME_CHANNELS = {
  KAVA_NOTIFICATION:
    process.env.REACT_APP_RT_KAVA_NOTIFICATION_CHANNEL || "kava-notification",
  KEK_CHANNEL: process.env.REACT_APP_RT_KEK_CHANNEL || "kava-kek-notification",
  CLOSED_BUSINESS:
    process.env.REACT_APP_RT_CLOSED_BUSINESS_CHANNEL ||
    "LgzULSz64aed7WJ7YwDq3qmHAeX786dZNZ3Ko4Bisf0",
  SAMPLE_CHANNEL:
    process.env.REACT_APP_RT_SAMPLE_CHANNEL || "kava-placeit-notification",
} as const;
